import css from 'styled-jsx/css';

export default css`
  .pc-model-intro-specs {
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    color: #fd0300;
    padding: 0;
    border: 0;
  }

  .pc-model-intro-specs .text {
    margin-left: 5px;
    font-size: 16px;
  }
`;
